export default {
  "file-progress": "_file-progress_imho69",
  "info": "_info_imho69",
  "details": "_details_imho69 body-2",
  "filename": "_filename_imho69",
  "filename--link": "_filename--link_imho69",
  "progress": "_progress_imho69",
  "progress-bar": "_progress-bar_imho69"
};